var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen",class:{active: _vm.isLoading},style:({ backgroundColor: _vm.backgroundColor})},[_c('img',{class:{'visible': _vm.globalsLoaded},attrs:{"src":_vm.logo.filename,"alt":"Logo Ausdrucksfotographie, Caroline Staeger"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }